module.exports = Object.freeze({
  No_Unfreeze_Request: { value: 0, name: 'No Unfreeze Request' },
  Pending_Approval: { value: 1, name: 'Pending Approval' },
  Approved: { value: 2, name: 'Approved' },
  Rejected: { value: 3, name: 'Rejected' }
});
